<template>
  <div>
    <form
      class="form"
      @submit.prevent="submitForm"
    >
      <div class="form__row form__row--space-below">
        <div class="form__column--half">
          <label
            class="form__label"
            for="first_name"
          >Full Name <span class="form__required">*</span></label>
          <input
            id="first_name"
            v-model="fields.first_name"
            type="text"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.first_name }"
            name="first_name"
            placeholder="First Name"
          >
          <div
            v-if="errors && errors.first_name"
            class="form__message form__message--error"
          >
            {{ errors.first_name[0] }}
          </div>
        </div>
        <div class="form__column--half">
          <input
            id="last_name"
            v-model="fields.last_name"
            type="text"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.last_name }"
            name="last_name"
            placeholder="Last Name"
          >
          <div
            v-if="errors && errors.last_name"
            class="form__message form__message--error"
          >
            {{ errors.last_name[0] }}
          </div>
        </div>
      </div>

      <div class="form__row form__row--space-below">
        <div class="form__column--half">
          <label
            for="email"
            class="form__label"
          >E-mail <span class="form__required">*</span></label>
          <input
            id="email"
            v-model="fields.email"
            type="email"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.email }"
            name="email"
          >
          <div
            v-if="errors && errors.email"
            class="form__message form__message--error"
          >
            {{ errors.email[0] }}
          </div>
        </div>
        <div class="form__column--half">
          <label
            for="phone"
            class="form__label"
          >Phone Number <span class="form__required">*</span></label>
          <input
            id="phone"
            v-model="fields.phone"
            v-mask="{ mask: '999-999-9999', jitMasking: true }"
            type="tel"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.phone }"
            name="phone"
          >
          <div
            v-if="errors && errors.phone"
            class="form__message form__message--error"
          >
            {{ errors.phone[0] }}
          </div>
        </div>
      </div>

      <div class="form__row form__row--space-below align_item_unset">
        <div class="form__column--half">
          <label
            for="address_line"
            class="form__label"
          >Street <span class="form__required">*</span></label>
          <input
            id="address_line"
            v-model="fields.address"
            type="text"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.address }"
            name="address"
          >
          <div
            v-if="errors && errors.address"
            class="form__message form__message--error"
          >
            {{ errors.address[0] }}
          </div>
        </div>
        <div class="form__column--half">
          <label
            for="province"
            class="form__label"
          >Province or Territory <span class="form__required">*</span></label>
          <section class="form__select">
            <select
              id="province"
              v-model="fields.province"
              class="form__input--dark"
              :class="{ 'has-error': errors.province }"
              name="province"
              @change="getProvinceOrganization"
            >
              <option
                v-for="(item) in provinces"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </section>
          <div
            v-if="errors && errors.province"
            class="form__message form__message--error"
          >
            {{ errors.province[0] }}
          </div>
        </div>
      </div>

      <div class="form__row form__row--space-below">
        <div class="form__column--full">
          <label
            class="form__checkbox--label container"
            for="member_of_chamber_or_bot"
          >
            <input
              id="member_of_chamber_or_bot"
              v-model="fields.member_of_chamber_or_bot"
              type="checkbox"
            >
            <span class="checkmark" />
            <label
              for="member_of_chamber_or_bot"
              style="margin-top: 5px !important; margin: 2px !important"
            > Member of Chamber or Board of Trade</label>
          </label>
          <div
            v-if="errors && errors.member_of_chamber_or_bot"
            class="form__message form__message--error"
          >
            {{ errors.member_of_chamber_or_bot[0] }}
          </div>
        </div>
      </div>

      <div class="form__row form__row--space-below">
        <div class="form__column--full">
          <label
            for="select_chamber_bot"
            class="form__label"
            :class="!fields.member_of_chamber_or_bot ? 'color_gray' : 'color_black'"
          >
            Select the Chamber or Board of Trade <span class="form__required">*</span></label>
          <section
            class="form__select"
            :class="[!fields.member_of_chamber_or_bot ? 'form__select__disabled' : '', !fields.member_of_chamber_or_bot ? 'form__select__focus__disabled' : '']"
          >
            <select
              id="select_chamber_bot"
              v-model="fields.select_chamber_bot"
              class="form__input--dark form-select"
              :class="{ 'has-error': errors.select_chamber_bot , 'cursor-not-allowed' : !fields.member_of_chamber_or_bot }"
              name="select_chamber_bot"
              :disabled="!fields.member_of_chamber_or_bot"
            >
              <option
                v-for="(item) in provinceOrganizationsOptions"
                :key="item.custom_id"
                :value="item.custom_id"
              >
                {{ item.name }}
              </option>
            </select>
          </section>
          <div
            v-if="errors && errors.select_chamber_bot"
            class="form__message form__message--error"
          >
            {{ errors.select_chamber_bot[0] }}
          </div>
        </div>
      </div>

      <!--      <div class="form__row form__row&#45;&#45;space-below">-->
      <!--        <div class="form__column&#45;&#45;half">-->
      <!--          <label-->
      <!--            for="organization"-->
      <!--            class="form__label"-->
      <!--          >Organization <span class="form__required">*</span></label>-->
      <!--          <section class="form__select">-->
      <!--            <select-->
      <!--              id="organization"-->
      <!--              v-model="fields.organization"-->
      <!--              class="form__input&#45;&#45;dark"-->
      <!--              :class="{ 'has-error': errors.organization }"-->
      <!--              name="organization"-->
      <!--              @change="getSubOrganization"-->
      <!--            >-->
      <!--              <option-->
      <!--                v-for="(item) in organizationOptions"-->
      <!--                :key="item.id"-->
      <!--                :value="item.id"-->
      <!--              >-->
      <!--                {{ item.name }}-->
      <!--              </option>-->
      <!--            </select>-->
      <!--          </section>-->
      <!--          <div-->
      <!--            v-if="errors && errors.organization"-->
      <!--            class="form__message form__message&#45;&#45;error"-->
      <!--          >-->
      <!--            {{ errors.organization[0] }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="form__column&#45;&#45;half">-->
      <!--          <label-->
      <!--            for="sub_organization"-->
      <!--            class="form__label"-->
      <!--          >Sub Organization</label>-->
      <!--          <section class="form__select">-->
      <!--            <select-->
      <!--              id="sub_organization"-->
      <!--              v-model="fields.sub_organization"-->
      <!--              class="form__input&#45;&#45;dark"-->
      <!--              :class="{ 'has-error': errors.sub_organization }"-->
      <!--              name="sub_organization"-->
      <!--            >-->
      <!--              <option-->
      <!--                v-for="(item) in subOrganizationOptions"-->
      <!--                :key="item.id"-->
      <!--                :value="item.id"-->
      <!--              >-->
      <!--                {{ item.name }}-->
      <!--              </option>-->
      <!--            </select>-->
      <!--          </section>-->
      <!--          <div-->
      <!--            v-if="errors && errors.sub_organization"-->
      <!--            class="form__message form__message&#45;&#45;error"-->
      <!--          >-->
      <!--            {{ errors.sub_organization[0] }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="form__row form__row--space-below">
        <div class="form__column--full">
          <label
            class="form__label"
            for="business_name"
          >Business Name <span class="form__required">*</span></label>
          <input
            id="business_name"
            v-model="fields.business_name"
            type="text"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.business_name }"
            name="business_name"
          >
          <div
            v-if="errors && errors.business_name"
            class="form__message form__message--error"
          >
            {{ errors.business_name[0] }}
          </div>
        </div>
      </div>

      <div class="form__row form__row--space-below">
        <div class="form__column--full">
          <label
            for="website"
            class="form__label"
          >Website</label>
          <input
            id="website"
            v-model="fields.website"
            type="text"
            class="form__input form__input--dark"
            :class="{ 'has-error': errors.website }"
            name="website"
          >
          <div
            v-if="errors && errors.website"
            class="form__message form__message--error"
          >
            {{ errors.website[0] }}
          </div>
        </div>
      </div>

      <!--      <div class="form__row form__row&#45;&#45;space-below">-->
      <!--        <div class="form__column&#45;&#45;full">-->
      <!--          <label-->
      <!--            class="form__checkbox&#45;&#45;label"-->
      <!--            for="member_interest"-->
      <!--          >-->
      <!--            <input-->
      <!--              id="member_interest"-->
      <!--              v-model="fields.member_interest"-->
      <!--              type="checkbox"-->
      <!--            >-->
      <!--            <label-->
      <!--              for="member_interest"-->
      <!--            >Are you interested in learning more about becoming a Winnipeg-->
      <!--              Chamber Member?-->
      <!--            </label>-->
      <!--          </label>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="form__row">
        <div class="form__column--full">
          <div
            class="form__captcha"
            :class="{ 'has-error': errors['h-captcha-response'] }"
          >
            <vue-hcaptcha
              sitekey="ff3175d8-bb30-44fd-9266-989b2dc90def"
              name="hcaptcha"
              data-callback="submitForm"
              @verify="onVerify"
            />
          </div>
          <div
            v-if="errors && errors['h-captcha-response']"
            class="form__message form__message--error"
          >
            {{ errors['h-captcha-response'][0] }}
          </div>
        </div>
      </div>

      <div class="form__row form__row--space-below">
        <div class="form__column--full">
          <button
            class="form__button form__button--orange"
            type="submit"
            :disabled="!loaded"
          >
            <template v-if="loaded || success">
              Submit
            </template>
            <template v-else>
              Loading
            </template>
          </button>
        </div>
      </div>
      <div class="form__row">
        <div class="form__column--full">
          <div
            v-if="success"
            class="form__message form__message--success"
          >
            Message sent!
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

export default {
  components: {
    VueHcaptcha,
  },
  props: {
    webRoutes: { required: true, type: Object },
    organizationKey: { type: String },
  },
  data() {
      return {
          isActive:false,
          provinces:[],
          provinceOrganizationsOptions:[],
          fields: {},
          errors: {},
          errorMessage: null,
          success: false,
          loaded: true,
          verified: false,
          organizationOptions: [
              {name: 'Select Organization', id: ''}
          ],
          subOrganizationOptions: [
              {name: 'Select Sub Organization', id: ''}
          ],
      };
  },
    watch: {
        'fields.member_of_chamber_or_bot': function(newVal) {
            if (!newVal) {
                this.fields.select_chamber_bot = ''; // Clear the selected value
            }
        }
    },
    async mounted() {
        // let url = this.webRoutes.getOrganization;
        // if(this.organizationKey != 0){
        //     url = this.webRoutes.getOrganization+'/'+this.organizationKey;
        // }
        // let organizations = await axios.get(url);
        // if(organizations.status === 200){
        //     this.organizationOptions = organizations.data;
        //     if(this.organizationKey != 0){
        //         this.fields.organization = this.organizationKey;
        //         this.getSubOrganization();
        //     }
        // }

        let url = this.webRoutes.getProvince;
        let provinces = await axios.get(url);
        if(provinces.status === 200){
            this.provinces = provinces.data;
        }
    },
    methods: {
    async getSubOrganization() {
        let subOrganizations = await axios.get('get-sub-organizations/' + this.fields.organization);
        if (subOrganizations.status === 200) {
            this.subOrganizationOptions = subOrganizations.data;
        }
    },
        async getProvinceOrganization() {
            let provinceOrganizations = await axios.get('get-province-organizations/' + this.fields.province);
            if (provinceOrganizations.status === 200) {
                this.provinceOrganizationsOptions = provinceOrganizations.data;
                this.fields.select_chamber_bot = '';
            }
        },
    onVerify(response) {
      this.verified = true;
      this.fields['h-captcha-response'] = response;
    },

    requestSubmit() {
      return axios.post(this.webRoutes.submit, this.fields);
    },

    submitForm() {
      if (this.loaded) {
        this.loaded = false;
        this.success = false;
        this.errorMessage = null;
        this.errors = {};
        this.verified = true;

        this.requestSubmit()
            .then((response) => {
                this.fields = {}; //Clear input fields.
                this.subOrganizationOptions= [
                    {name: 'Select Sub Organization', id: ''}
                ];
                // Reset hcaptcha component
                grecaptcha.reset();
                this.provinceOrganizationsOptions = []; // Clear the provinceOrganizationsOptions array.
                this.loaded = true;
                // this.success = true;
                this.verified = false;
                this.$toasted.show('Your message was sent successfully', {
                    type: 'success',
                    position: 'bottom-right',
                    duration: 5000
                });
            })
          .catch((error) => {
            this.loaded = true;
            this.verified = false;
            grecaptcha.reset();
            if (error.response.status === 422 || !this.verified) {
              this.errors = error.response.data.errors || {};
              this.errorMessage = error.response.data.message;
            }
          });
      }
    },
  },
};
</script>
<style scoped>
    .cursor-not-allowed {
        cursor: not-allowed !important;
    }

    /* The container */
    .container {
        display: block;
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        /*font-size: 22px;*/
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.25rem;
        width: 1.25rem;
        background-color: #eee;
        border-radius: 2px;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        /*background-color: #ccc;*/
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #f37121;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 8px;
        top: 3px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .form__checkbox--label {
        display: flex !important;
        align-items: center !important;
    }

    .form__checkbox--label input[type="checkbox"] {
        margin-right: 4px !important;
    }

    /* Change label color when checkbox is not checked */
    .container input:not(:checked) ~ label {
        color: #757589;
    }

    /* Change label color back to black when checkbox is checked */
    .container input:checked ~ label {
        color: black;
    }

    .color_gray {
        color: #757589 !important;
    }

    .color_default {
        color: black !important;
    }

    .align_item_unset {
        align-items: unset !important;
    }
</style>
